import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const NearbyStore = Loadable({
    loader: () => import('./NearbyStore'),
    render(loaded, props) {
      const Component = connect((state) => ({
        nearbyStoreState: state.nearbyStoreState,
        siteConfig: state.siteConfig
      }), {
        init
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/nearby-store'
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <NearbyStore {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
